import Component from 'vue-class-component';
import Vue from 'vue';

@Component({})
export class Env extends Vue {
  //TODO: set dateformat based on browser language
  env = process.env;
}
